import { ROUTE_TO_MODAL_ID } from 'modules/routes/constants/index.cjs'

function getModalIdRouteUtil (path) {
  const routePath = Object
    .keys(ROUTE_TO_MODAL_ID)
    .find((routePath) =>
      path.startsWith(routePath)
    )
  return ROUTE_TO_MODAL_ID[routePath]
}

export {
  getModalIdRouteUtil
}
